"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.insightUpdatedComparator = exports.insightCreatedComparator = exports.insightUpdatedByComparator = exports.insightCreatedByComparator = exports.insightTitleComparator = void 0;
var index_1 = require("./index");
var comparators_1 = require("../base/comparators");
/**
 * @beta
 */
exports.insightTitleComparator = comparators_1.stringComparatorFactory(index_1.insightTitle);
/**
 * @beta
 */
exports.insightCreatedByComparator = comparators_1.stringComparatorFactory(function (i) { var _a; return (_a = index_1.insightCreatedBy(i)) === null || _a === void 0 ? void 0 : _a.fullName; });
/**
 * @beta
 */
exports.insightUpdatedByComparator = comparators_1.stringComparatorFactory(function (i) { var _a; return (_a = index_1.insightUpdatedBy(i)) === null || _a === void 0 ? void 0 : _a.fullName; });
/**
 * @beta
 */
exports.insightCreatedComparator = comparators_1.stringComparatorFactory(index_1.insightCreated);
/**
 * @beta
 */
exports.insightUpdatedComparator = comparators_1.stringComparatorFactory(index_1.insightUpdated);
//# sourceMappingURL=comparators.js.map